module.exports = __webpack_public_path__ + "img/depmap_svg_V34.4963e74e.svg";